import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";
import { UserRoleEnum } from "src/app/shared/models/enums/user-role.enum";
import { User } from "src/app/shared/models/user.model";

@Component({
	selector: "app-about-me",
	templateUrl: "./about-me.component.html",
	styleUrls: ["../customer.scss"],
})
export class AboutMeComponent implements OnInit {
	customerKey: string;
	constructor(public app: AppService, private activatedRoute: ActivatedRoute, private focuslink: FocuslinkService) {}

	ngOnInit(): void {
		this.app.titleService.setTitle("Focus POS Cloud");
		const b64CustomerKey = this.activatedRoute.snapshot.queryParamMap.get("customerKey");
		console.log(b64CustomerKey);
		if (b64CustomerKey) {
			const userKey = atob(b64CustomerKey).split("#")[1];
			const customerKey = atob(b64CustomerKey).split("#")[0];
			this.validateLoginBypassRequest(userKey, customerKey);
		}
	}

	async validateLoginBypassRequest(userKey: string, customerKey: string): Promise<any> {
		const resp = await this.focuslink.userGet(userKey);
		const user = new User(resp);
		if (user.role !== UserRoleEnum.SUPERADMIN && user.role !== UserRoleEnum.GOD) {
			this.app.msgSvc.add({ severity: AppMessageSeverity.RED, summary: "", detail: `Direct access prohibited. Invalid challenge.` });
			return;
		}
		this.customerKey = customerKey;
		return;
	}
}
